import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Button } from "@material-ui/core";

import ButtonClose from "../../../../../../../../util/buttonClose/.mixins/buttonClose";

export default function ModalEscolhaNovaOpcaoPag({ isModalOpen, handleDialogModal }) {
    function HeaderModal() {
        return (
            <Typography
                variant="button"
                align="center"
                display="block"
                style={{ marginLeft: "20px", fontSize: "15px" }}
            >
                Opções de recebimento definidas com sucesso!
                <ButtonClose closeMethod={handleDialogModal} />
            </Typography>
        );
    }

    function BodyModal() {
        return (
            <div align="center">
                <Typography variant="subtitle1" align="center" gutterBottom>
                    <strong>A nova data de pagamento já está registrda em nosso sistema.</strong>
                </Typography>
                <Typography variant="subtitle1" align="center">
                    você pode alterar a opção de recebimento até 1 dia antes da data agendada de
                    entrega.
                </Typography>
            </div>
        );
    }

    function ButtonModal() {
        return (
            <>
                <Typography style={{ padding: "0px", marginBottom: "32.5px" }} align="center">
                    <Button
                        variant="contained"
                        onClick={handleDialogModal}
                        color="primary"
                        style={{ padding: "7.5px 20px" }}
                    >
                        Entendido
                    </Button>
                </Typography>
            </>
        );
    }

    return (
        <Dialog open={isModalOpen} scroll="paper">
            <DialogTitle>
                <HeaderModal />
            </DialogTitle>

            <DialogContent>
                <BodyModal />
            </DialogContent>

            <ButtonModal />
        </Dialog>
    );
}
